<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-pdf rounded-pill">
  <i class="bi bi-file-earmark-pdf-fill"></i>
    {{label}}
</button>
